<!-- Modal backdrop con animación de fade -->
@if (modalViewLocationService.isOpen$ | async) {
  <div
    class="fixed inset-0 bg-black/60 z-100 flex items-center justify-center transition-opacity duration-300 ease-in-out overflow-y-auto py-10"
    [class.animate-fadeOut]="(modalViewLocationService.isClosing$ | async)"
    (click)="closeModal()"
    >
    <!-- Contenedor del modal con animación de entrada y salida -->
    <div
      class="bg-white rounded-lg shadow-md w-11/12 sm:w-10/12 md:w-9/12 lg:w-8/12 max-w-2xl mx-auto z-50 overflow-hidden transform transition-all duration-300 ease-in-out"
      [class.animate-fadeOut]="(modalViewLocationService.isClosing$ | async)"
      (click)="$event.stopPropagation()"
      >
      <!-- Cabecera del modal -->
      <div
        class="px-4 sm:px-6 py-3 sm:py-4 border-b border-amber-300 flex justify-between items-center bg-amber-400"
        >
        @if ((modalViewLocationService.editMode$ | async) == false) {
          <h3
          class="text-base sm:text-lg font-medium text-black">Buscar ubicación</h3>
        }
        @if ((modalViewLocationService.editMode$ | async) == true) {
          <h3
          class="text-base sm:text-lg font-medium text-black">Editar ubicación</h3>
        }
        <button
          (click)="closeModal()"
          class="text-black hover:text-gray-800 focus:outline-none transition-transform duration-300 hover:scale-110"
          >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="1.5"
            >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <!-- Cuerpo del modal -->
        <div class="height-modal p-6">
          <!-- Componente de búsqueda -->
          <modal-view-search-bar-addresses
            (locationSelected)="onLocationSelected($event)"
          ></modal-view-search-bar-addresses>
          <!-- Botón para mostrar/ocultar mapa -->
          <div class="mt-3 sm:mt-4 flex justify-center">
            <button
              (click)="toggleMapVisibility()"
              class="px-3 sm:px-4 py-2 bg-green-500 text-white rounded-full hover:bg-green-600 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-50 flex items-center space-x-2 transform hover:scale-105 text-sm sm:text-base shadow-sm"
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="1.5"
                >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4"
                  />
                </svg>
                <span>{{ showMap ? 'Ocultar mapa' : 'Mostrar mapa' }}</span>
              </button>
            </div>
            <!-- Componente de mapa (condicional) -->
            @if (showMap) {
              <div class="mt-4 animate-fadeIn">
                <modal-view-map
                  [initialLocation]="currentLocation"
                  [draggableMarker]="true"
                  (locationChanged)="onLocationSelected($event)"
                  >
                </modal-view-map>
                <!-- Botón para obtener ubicación actual -->
                <div class="mt-3">
                  <modal-view-current-location-button
                    (locationSelected)="onLocationSelected($event)"
                  ></modal-view-current-location-button>
                </div>
                <!-- Mensaje informativo sobre cómo usar el mapa -->
                <div
                  class="mt-2 text-sm text-gray-600 flex items-center justify-center"
                  >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 mr-1 text-green-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="1.5"
                    >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <span
                      >Puedes hacer clic en el mapa o arrastrar el marcador para
                      seleccionar una ubicación</span
                      >
                    </div>
                    <modal-view-location-form-save-address></modal-view-location-form-save-address>
                  </div>
                }
                <!-- Listado de direcciones guardadas -->
                @if ((modalViewLocationService.editMode$ | async) == false) {
                  <div
                    class="mt-4 max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-amber-400 scrollbar-track-gray-100 hover:scrollbar-thumb-amber-500">
                    <modal-view-location-list-addresses></modal-view-location-list-addresses>
                  </div>
                }
              </div>
              <!-- Pie del modal -->
              <div class="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-100 bg-white flex flex-col sm:flex-row sm:justify-end gap-2">
                @if ((modalViewLocationService.editMode$ | async) == false) {
                  <button
                    (click)="closeModal()"
                    class="px-3 sm:px-4 py-2 bg-gray-200 text-black rounded-md hover:bg-gray-300 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-50 w-full sm:w-auto text-sm sm:text-base shadow-sm"
                    >
                    Cancelar
                  </button>
                }
                <!-- <button
                (click)="closeModal()"
                class="px-3 sm:px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-50 w-full sm:w-auto text-sm sm:text-base shadow-sm"
                >
                Confirmar ubicación
              </button> -->
            </div>
          </div>
        </div>
      }
